export default __webpack_public_path__ + "static/media/postpaddy-dashboard.8915d669.png";